<template>
  <div class="addActivities">
    <div class="main">
       <div class="box">
          <div class="box-left">
            昵称：<span>{{form.wxName}}</span>
          </div>
          <div class="box-right">
            打卡酒吧：<span>{{form.barName}}</span>
          </div>
       </div>
        <div class="box">
          <div class="box-left">
            评分：<span> <el-rate v-model="form.score" disabled></el-rate></span>
          </div>
          <div class="box-right">
            打卡时间：<span>{{form.createTime}}</span>
          </div>
       </div>
       <div class="box">
          <div class="box-right">
            评价内容：<span>{{form.essay}}</span>
          </div>
       </div>
        <div class="box" v-if="form.labelContent.length>0">
          <div class="box-label" >
            评价标签：
            <div v-for="(item,i) in form.labelContent" :key='i' >
                   {{item}}
            </div>
          </div>
       </div>
        <div class="box">
          <div >
             <div> 评价照片：</div>
             <div class="box-img">
                <el-image class="img" :src="item.url" v-for="(item,i) in form.images" :key='i'   :preview-src-list='[item.url]'></el-image>
             </div>
         
          </div>
       </div>
    </div>
   
      <el-button v-if="form.auditType==3" type="success" @click="examine(form.commentId,2)">上架</el-button>
      <el-button v-if="form.auditType==2" type="danger" @click="examine(form.commentId,3)">下架</el-button>

  </div>
</template>

<script>
import { IP, webCommentExamine, webCommentDetail } from "@/api/api";

export default {
  data() {
    const self = this;
    return {
      form: {
        commentId: "",
        wxName: "",
        barName: "",
        score: null,
        createTime: [],
        essay: "",
        labelContent: "",
        auditType:''
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    //  获取详情
    async getDetail() {
      let res = await webCommentDetail({
        commentId: this.$route.query.commentId,
      });

      this.form.commentId = this.$route.query.commentId;
      this.form.wxName = res.data.wxName; //
      this.form.barName = res.data.barName
      this.form.score = res.data.score //
      this.form.createTime = res.data.createTime
      this.form.essay = res.data.essay;
      this.form.images = res.data.images;
      if(res.data.labelContent){

        this.form.labelContent = res.data.labelContent.split(",");
      }
      this.form.auditType=res.data.auditType
      console.log(this.form);
      
    },

    async examine(id, type) {
      let res = await webCommentExamine({
        commentId: id,
        type: type,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.$router.push("clockManage?currentPage="+this.$route.query.currentPage+"&pageSize="+this.$route.query.pageSize+"&query="+this.$route.query.query+ "&value=" +
          this.$route.query.value);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.addActivities {
  background: #fff;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: scroll;
  .main {
    padding: 60px;
    .box {
      display: flex;
      margin-bottom: 35px;
      .box-left {
        width: 200px;
        display: flex;
        align-items: center;
      }
      .box-label {
        display: flex;
        align-items: center;
        div {
          padding: 10px 20px;
          background: #ffb423;
          margin-left: 16px;
          border-radius: 5px;
        }
      }
      .box-img {
        margin-top: 23px;
        .img {
          width: 200px;
          height: 160px;
          margin-right: 26px;
        }
      }
    }
  }
  .btn{
    padding:0 60px;
  }
}
</style>